module.exports = new __parcel__URL__("Smoke15Frames_White.563ab519.png").toString();